import React, { useEffect, useState } from 'react';
import {  useApi } from '@backstage/core-plugin-api';
import { swTemplateCustomApiRef } from '../../../../apis/swTemplateCustomApi';
import { NotificationApi, notificationApiRef } from '../../../../apis/notificationApi';

export const useGetImage = (uid: string | undefined) => {
  const notificationApi: NotificationApi = useApi(notificationApiRef);

  const [imageSrc, setImageSrc] = useState<string | undefined>();
  
  const swTemplateCustomApi = useApi(swTemplateCustomApiRef);

  useEffect(() => {
    if (uid) {
      swTemplateCustomApi.getImage(`${uid}.png`)
        .then((imageResponse: any) => {
          const contentType = imageResponse?.contentType || 'image/png';
          const base64Payload = imageResponse?.imageBase64;

          if (typeof base64Payload === 'string' && base64Payload.length > 0) {
            if (contentType.toLowerCase().includes('text/html')) {
              setImageSrc(undefined);
              return;
            }

            const src = base64Payload.startsWith('data:')
              ? base64Payload
              : `data:${contentType};base64,${base64Payload}`;
            setImageSrc(src);
          } else {
            setImageSrc(undefined);
          }
        })
        .catch((err: any) => {
          notificationApi.sendNotification({
            message: `Error occurred - ${err?.message}`,
            disapperAfterMs: 2500,
            severity: 'error',
          });
          setImageSrc(undefined);
        });
    } else {
      setImageSrc(undefined);
    }
  }, [uid, notificationApi, swTemplateCustomApi]);

  return [imageSrc];
};
